import React, { Component } from 'react';
import { Result, message } from 'antd';

const logErrorToConsole = (error, errorInfo) => {
  console.log(error, errorInfo);
};

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, offline: false };
  }

  componentDidMount() {
    window.addEventListener('online', () => {
      this.setState({ ...this.state, offline: false });
      message.success('Back online');
    });
    window.addEventListener('offline', () => {
      this.setState({ ...this.state, offline: true });
      message.error('You are currently offline');
    });
  }

  static getDerivedStateFromError(_error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    logErrorToConsole(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100vw',
            height: '100vh'
          }}>
          <Result status="warning" title="Something went wrong" />
        </div>
      );
    }

    return (
      <div className="app">
        <div className="app-container">{this.props.children}</div>
        {this.state.offline && (
          <div
            style={{
              position: 'fixed',
              zIndex: 1002,
              left: 0,
              right: 0,
              top: 0,
              bottom: 0,
              background: 'rgba(255, 255, 255, 0.85)'
            }}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100vw',
                height: '100vh'
              }}>
              <div className="offline"></div>
              <p style={{ fontSize: 16, paddingTop: 20 }}>No internet! Reconnect to keep working</p>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default ErrorBoundary;
